import styled from 'styled-components';

export const BreadcrumbsNav = styled.div`
  margin-top: 12px;
`;

export const BreadcrumbItem = styled.li`
  a {
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
      color: #404040;
    }

    &:focus-visible {
      text-decoration: none;
    }
  }
`;
